import { Menu as MenuWrapper } from 'shared/components/Menu';

import { MenuItem } from './components/MenuItem';

import type { InspiredGlobalStudyPlatformApiModelsAccountStudent as Student } from 'applications/GSP/shared/api/gsp';
import type { FC } from 'react';
import type { AnchorEl } from 'shared/components/Menu/hooks/';

export interface MenuProps {
  students?: Student[];
  anchorEl: AnchorEl;
  open: boolean;
  onChange(student: Student): void;
  onClose(): void;
}

export const Menu: FC<MenuProps> = ({
  anchorEl,
  open,
  onClose,
  onChange,
  students = [],
}) => (
  <MenuWrapper anchorEl={anchorEl} open={open} onClose={onClose}>
    {students.map(student => (
      <MenuItem
        student={student}
        key={student.id}
        onClick={() => onChange(student)}
      />
    ))}
  </MenuWrapper>
);
